import i18n from './instance';
import { LANG_BCP47, type AppLang, isAppLang } from './locale';

export function activeLang(): AppLang {
  const lng = i18n.language?.split('-')[0];
  return isAppLang(lng) ? lng : 'fr';
}

export function activeLocale(): string {
  return LANG_BCP47[activeLang()];
}

export function formatNumber(
  value: number,
  options?: Intl.NumberFormatOptions,
): string {
  return value.toLocaleString(activeLocale(), options);
}

export function formatDate(
  date: Date | number | string,
  options?: Intl.DateTimeFormatOptions,
): string {
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleString(activeLocale(), options);
}

export function formatDateTimeShort(date: Date | number | string): string {
  const d = date instanceof Date ? date : new Date(date);
  return new Intl.DateTimeFormat(activeLocale(), {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(d);
}
